/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} General_DeletingInputs */

const en_general_deleting = /** @type {(inputs: General_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting...`)
};

const de_general_deleting = /** @type {(inputs: General_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gelöscht...`)
};

/**
* | output |
* | --- |
* | "Deleting..." |
*
* @param {General_DeletingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const general_deleting = /** @type {((inputs?: General_DeletingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_DeletingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_general_deleting(inputs)
	return de_general_deleting(inputs)
});